import { Injectable } from '@angular/core';
import { AgendaRepositoryService } from 'src/app/models/agenda/agenda-repository.service';
import { EventAcademy } from 'src/app/models/event/event.model';
import { MaintenanceReminder, MaintenanceReminderUser } from 'src/app/models/maintenance/maintenance.model';
import { News } from 'src/app/models/news/news.model';

@Injectable()
export class AgendaDialogService {

  private _dialogTile: string = '';

  private _agendaElement: News | EventAcademy;
  private _maintenanceReminder: MaintenanceReminder | MaintenanceReminderUser;

  constructor(private agendaRepo : AgendaRepositoryService) { }

  public get dialogTile(): string {
    return this._dialogTile;
  }
  public set dialogTile(value: string) {
    this._dialogTile = value;
  }

  public get agendaElement(): News | EventAcademy {
    return this._agendaElement;
  }
  public set agendaElement(value: News | EventAcademy) {
    this._agendaElement = value;
  }

  public get maintenanceReminder(): MaintenanceReminder | MaintenanceReminderUser {
    return this._maintenanceReminder;
  }
  public set maintenanceReminder(value: MaintenanceReminder | MaintenanceReminderUser) {
    this._maintenanceReminder = value;
  }

  hideElement() {
    this.agendaRepo.hideElement(this.agendaElement.id);
  }

  reset() {
    this.dialogTile = null;
    this.maintenanceReminder = null;
    this.agendaElement = null;

  }

}
